import { Button } from "@/projects/NPS/Stepper/common/button";

export const CTASection = () => {
  return (
    <section className="relative overflow-hidden bg-[linear-gradient(to_bottom_right,#0A344A,#0A344A,rgba(29,171,145,0.8))] py-16 sm:py-20 md:py-28">
      {/* Pattern Overlay */}
      <div
        className="pointer-events-none absolute inset-0 opacity-40"
        style={{
          backgroundImage:
            "url('data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.03'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E')",
        }}
      />

      {/* Blurred Circles */}
      <div className="absolute right-0 top-0 h-48 w-48 rounded-full bg-[rgba(29,171,145,0.2)] blur-2xl sm:h-72 sm:w-72 sm:blur-3xl md:h-96 md:w-96" />

      <div className="absolute bottom-0 left-0 h-48 w-48 rounded-full bg-white/5 blur-2xl sm:h-72 sm:w-72 sm:blur-3xl md:h-96 md:w-96" />

      <div className="relative mx-auto max-w-[1200px] px-4 sm:px-6">
        <div className="mx-auto max-w-3xl text-center text-white">
          {/* Badge */}
          <div className="animate-fade-in mb-6 inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/10 px-4 py-2 text-xs font-semibold backdrop-blur sm:mb-8 sm:text-sm">
            <svg
              width="4"
              height="4"
              className="sm:h-6 sm:w-6"
              fill="none"
              stroke="#1DAB91"
              strokeWidth="1"
            >
              <path d="m12 3-1.912 5.813a2 2 0 0 1-1.275 1.275L3 12l5.813 1.912a2 2 0 0 1 1.275 1.275L12 21l1.912-5.813a2 2 0 0 1 1.275-1.275L21 12l-5.813-1.912a2 2 0 0 1-1.275-1.275L12 3Z" />
            </svg>
            Start Your Investment Journey
          </div>

          {/* Title */}
          <h2 className="font-display animate-fade-in mb-6 text-2xl font-bold leading-tight delay-100 sm:text-3xl md:text-4xl lg:text-5xl">
            Ready to Grow Your Wealth?
          </h2>

          {/* Description */}
          <p className="animate-fade-in mx-auto mb-6 max-w-2xl text-base leading-relaxed text-white/80 delay-200 sm:mb-8 sm:text-lg md:text-xl">
            Join 50,000+ investors who trust FinEase for their investment needs.
            Start with as little as ₹100.
          </p>

          {/* Trust Points */}
          <div className="animate-fade-in mb-8 flex flex-col flex-wrap justify-center gap-4 text-sm text-white/70 delay-300 sm:flex-row sm:gap-6">
            <div className="flex items-center justify-center gap-2">
              <svg
                width="18"
                height="18"
                className="sm:h-6 sm:w-6"
                fill="none"
                stroke="#1DAB91"
                strokeWidth="1"
              >
                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                <polyline points="22 4 12 14.01 9 11.01" />
              </svg>
              No hidden charges
            </div>

            <div className="flex items-center justify-center gap-2">
              <svg
                width="18"
                height="18"
                className="sm:h-6 sm:w-6"
                fill="none"
                stroke="#1DAB91"
                strokeWidth="1"
              >
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
              </svg>
              SEBI registered
            </div>

            <div className="flex items-center justify-center gap-2">
              <svg
                width="18"
                height="18"
                className="sm:h-6 sm:w-6"
                fill="none"
                stroke="#1DAB91"
                strokeWidth="1"
              >
                <polyline points="22 7 13.5 15.5 8.5 10.5 2 17" />
                <polyline points="16 7 22 7 22 13" />
              </svg>
              High returns
            </div>
          </div>

          {/* Buttons */}
          <div className="animate-fade-in mb-8 mt-4 flex flex-col justify-center gap-4 delay-300 sm:flex-row">
            <Button
              variant="outline"
              className="inline-flex items-center justify-center gap-2 rounded-xl bg-white px-6 py-3 text-sm font-bold text-secondary shadow-lg transition hover:-translate-y-1 hover:shadow-2xl sm:px-8 sm:py-4 sm:text-base"
              role="button"
            >
              Create Free Account
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                className="sm:h-5 sm:w-5"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path d="M5 12h14M12 5l7 7-7 7" />
              </svg>
            </Button>

            <Button
              variant="outline"
              className="inline-flex items-center justify-center rounded-xl border border-white/30 px-6 py-3 text-sm text-white backdrop-blur transition hover:bg-white/10 sm:px-8 sm:py-4 sm:text-base"
              role="button"
            >
              Explore Products
            </Button>
          </div>

          {/* Social Proof */}
          <div className="animate-fade-in flex flex-col items-center justify-center gap-3 pt-4 delay-500 sm:flex-row">
            {/* Avatars */}
            <div className="flex justify-center">
              {[1, 2, 3, 4].map(item => (
                <div
                  key={item}
                  className={`flex h-9 w-9 items-center justify-center rounded-full border-2 border-white/20 bg-[rgba(29,171,145,0.6)] sm:h-10 sm:w-10 ${item === 1 ? "ml-0" : "-ml-2"}`}
                >
                  {/* Inline SVG Icon */}
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                    <circle cx="9" cy="7" r="4" />
                  </svg>
                </div>
              ))}
            </div>

            {/* Trust Text */}
            <p className="mt-2 text-xs text-white/70 sm:mt-0 sm:text-sm">
              <span className="font-semibold text-white">50,000+</span>{" "}
              investors trust us
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
